import { Component, OnInit } from '@angular/core';
import { Platform, NavController, MenuController, NavParams } from 'ionic-angular';
import { GoogleAnalytics } from '@ionic-native/google-analytics/ngx';

import { ObservationsService } from '../../app/shared/services/observations.service';
import { AuthService } from '../../app/shared/services/auth.service';
import { LastScansService } from '../../app/shared/services/lastScans.service';

import { HomepageComponent } from '../home/home';
import { DetailsObservationComponent } from '../details-observation/details-observation';
import { FiltresComponent } from '../filtres/filtres';

@Component({
    selector: 'page-liste-observations-rapport',
    templateUrl: './liste-observations-rapport.html'
})
export class ListeObservationsRapportComponent implements OnInit {
    liste: Array<any> = [];
    res: any = { paging: {} };
    filtres: any = {};
    scrollInfinite: boolean = true;
    loader: boolean = true;
    hasCritique: boolean = true;
    rapportId: number = 0;
    offset: number;
    pageSize: number;
    search: string = '';

    constructor(
    private platform: Platform,
     private ga: GoogleAnalytics,
     private menuCtrl: MenuController,
     private navCtrl: NavController,
     private navParams: NavParams,
     private authService: AuthService,
     private lastScansService: LastScansService,
     private observationsService: ObservationsService
    ) {
        this.platform.ready().then(_ => {
            this.ga.trackView("Liste observations rapports");
        });
    }

    ngOnInit() {
        this.rapportId = this.navParams.get("rapportId") || 0;
        this.filtres = this.navParams.get("filtres") || {};
    }

    async ionViewWillEnter(): Promise<any> {
        const liste = await this.lastScansService.getLastScans();
        const token = await this.authService.getToken();
        if (liste !== null) {
            for (let i in liste) {
                if (liste[i].user == token.user) {
                    this.hasCritique = (liste[i].scans[0].data.hasObservationCritique === true || liste[i].scans[0].data.nombreObservationsCritiques > 0);
                    break;
                }
            }
        }
        if (Object.keys(this.filtres).length === 0){
            this.getListe();
        } else {
            this.getFiltres();
        }
    }

    getListe(): any {
        this.offset = 0;
        this.pageSize = 20;
        this.scrollInfinite = true;
        this.loader = true;
        this.observationsService.getListObservationsRapport(this.rapportId, this.offset, this.pageSize).subscribe(
            (res: any) => {
                this.res = res;
                this.liste = res.data;
                this.loader = false;
                if (res.paging.totalRecordCount <= this.offset + this.pageSize) {
                    this.scrollInfinite = false;
                }
            },
            (error: any) => {
                this.gestionErreur(error);
            }
        );
    }

    getSearch(search: string): any {
        this.filtres = {};

        if(search != '') {
            this.scrollInfinite = true;
            this.loader = true;
            this.search = search;
            this.offset = 0;
            this.pageSize = 20;
            this.observationsService.getSearchObservationsRapport(this.rapportId, this.search, this.offset, this.pageSize).subscribe(
                (res: any) => {
                    this.res = res;
                    this.liste = res.data;
                    this.loader = false;
                    if (res.paging.totalRecordCount <= this.offset + this.pageSize) {
                        this.scrollInfinite = false;
                    }
                },
                (error: any) => {
                    this.gestionErreur(error);
                }
            );
        } else if (this.search != '') {
            this.search = '';
            this.getListe();
        }
    }

    getFiltres(): any {
        this.loader = true;
        this.offset = 0;
        this.pageSize = 20;
        this.search = '';
        this.filtres._observations = (this.filtres._observations === '2') ? null : this.filtres._observations;
        this.observationsService.getFiltresObservationsRapport(
            this.rapportId,
            this.offset,
            this.pageSize,
            this.filtres._level1,
            this.filtres._level2,
            this.filtres._level3,
            this.filtres._observations
        ).subscribe(
            (res: any) => {
                this.res = res;
                this.liste = res.data;
                this.loader = false;
                if (res.paging.totalRecordCount <= this.offset + this.pageSize) {
                    this.scrollInfinite = false;
                }
            },
            (error: any) => {
                this.gestionErreur(error);
            }
        );
    }

    goToFilter(): any {
        this.navCtrl.push(FiltresComponent, { rapportId: this.rapportId, isObservation: true, hasFilterType: true, filtres: this.filtres });
    }

    getObservation(item: any): any {
        this.navCtrl.push(DetailsObservationComponent, { listeObservations: this.liste, details: item });
    }

    doInfinite(): Promise<any> {
        this.offset += this.res.paging.pageSize;
        this.pageSize = (this.res.paging.totalRecordCount > this.offset + this.res.paging.pageSize) ? this.res.paging.pageSize : this.res.paging.totalRecordCount - this.offset;

        return new Promise(
            (resolve) => {
                if (this.res.paging.totalRecordCount > this.offset) {
                    if (this.filtres !== undefined && Object.keys(this.filtres).length !== 0) {
                        this.observationsService.getFiltresObservationsRapport(
                            this.rapportId,
                            this.offset,
                            this.pageSize,
                            this.filtres._level1,
                            this.filtres._level2,
                            this.filtres._level3,
                            this.filtres._observations
                        ).subscribe(
                            (res: any) => {
                                this.res = res;
                                Array.prototype.push.apply(this.liste, res.data);
                                resolve();
                            },
                            (error: any) => {
                                this.gestionErreur(error);
                            }
                        );
                    } else if(this.search !== '') {
                        this.observationsService.getSearchObservationsRapport(this.rapportId, this.search, this.offset, this.pageSize).subscribe(
                            (res: any) => {
                                this.res = res;
                                Array.prototype.push.apply(this.liste, res.data);
                                resolve();
                            },
                            (error: any) => {
                                this.gestionErreur(error);
                            }
                        );
                    } else {
                        this.observationsService.getListObservationsRapport(this.rapportId, this.offset, this.pageSize).subscribe(
                            (res: any) => {
                                this.res = res;
                                Array.prototype.push.apply(this.liste, res.data);
                                resolve();
                            },
                            (error: any) => {
                                this.gestionErreur(error);
                            }
                        );
                    }
                } else {
                    this.scrollInfinite = false;
                }
            }
        );
    }

    async gestionErreur(error: any): Promise<any> {
        console.error(error);
        if (this.authService.refreshCalled) {
            this.authService.refreshCalled = false;
            this.navCtrl.setRoot(HomepageComponent);
        } else if (error.status === 401) {
            this.authService.refreshCalled = true;
            const refreshToken = await this.authService.getRefreshToken();
            if (refreshToken === null) {
                await this.authService.removeToken();
                await this.authService.removeRefreshToken();
                this.menuCtrl.enable(true, 'unauthenticated');
                this.menuCtrl.enable(false, 'authenticated');
                this.navCtrl.setRoot(HomepageComponent);
            } else {
                this.authService.refresh(refreshToken).subscribe(async data => {
                    const token = await this.authService.getToken()
                    await this.authService.setToken(token.user, data.access_token, data.statut);
                    await this.authService.setRefreshToken(data.refresh_token)
                    this.navCtrl.setRoot(ListeObservationsRapportComponent, { rapportId: this.rapportId });
                });
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/liste-observations-rapport/liste-observations-rapport.ts